var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "va-row" },
    [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c(
            "vuestic-widget",
            { attrs: { id: "datagridSettlement" } },
            [
              _c(
                "div",
                {
                  staticClass: "flex md4",
                  staticStyle: { "padding-top": "0", "padding-left": "0" },
                  attrs: { id: "createNewSettlement" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      on: { click: _vm.goApplySettlement },
                    },
                    [
                      _c("div", { staticClass: "btn-with-icon-content" }, [
                        _c("i", {
                          staticClass: "iconicstroke iconicstroke-plus",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("basic.button.newSettlement")) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "vuestic-data-table2",
                {
                  attrs: {
                    apiUrl: _vm.apiUrl,
                    data: _vm.apiData,
                    httpMethod: _vm.httpMethod,
                    tableFields: _vm.tableFields,
                    itemsPerPage: _vm.itemsPerPage,
                    defaultPerPage: _vm.defaultTablePerPage,
                    sortFunctions: _vm.sortFunctions,
                    apiMode: _vm.apiMode,
                    paginationPath: _vm.paginationPath,
                    queryParams: _vm.queryParams,
                    filterSelectShown: _vm.searchBarVisible,
                  },
                },
                [
                  _c("spring-spinner", {
                    attrs: {
                      slot: "loading",
                      "animation-duration": 2500,
                      size: 70,
                      color: "#4ae387",
                    },
                    slot: "loading",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vuestic-modal",
        {
          ref: "largeModal",
          attrs: {
            show: _vm.openFg,
            large: true,
            id: "detailModal",
            noButtons: true,
          },
          on: {
            "update:show": function ($event) {
              _vm.openFg = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(
              _vm._s(_vm._f("translate")("settlement_details.title")) +
                "  " +
                _vm._s(_vm._f("translate")("settlement_details.of")) +
                "  " +
                _vm._s(_vm._f("translate")("settlement_details.settlementId")) +
                '  "' +
                _vm._s(this.settlementId) +
                '"'
            ),
          ]),
          _c("settlement-details", {
            attrs: { "table-data": _vm.currentSelectedDetail },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }